export default () => ({
  link: { textDecoration: 'none' },
  disabled: { pointerEvents: 'none' }
});
